import React from 'react';
import { navigate } from 'gatsby';
import { Typography, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { namespaces } from 'core/i18n';
import { routes } from 'core/router';
import { keys } from '../../translations';
import { MenuComponent } from './menu.component';

interface Props {
  component: 'li';
  className?: string;
}

export const TerminalListComponent: React.FC<Props> = props => {
  const { component, className } = props;
  const { t } = useTranslation(namespaces.commonApp.appBar);

  return (
    <MenuComponent className={className} component={component} title={t(keys.terminals.title)}>
      <MenuItem onClick={() => navigate(routes.terminals.barcelona)}>
        <Typography variant="body1">{t(keys.terminals.barcelona)}</Typography>
      </MenuItem>
      <MenuItem onClick={() => navigate(routes.terminals.huelva)}>
        <Typography variant="body1">{t(keys.terminals.huelva)}</Typography>
      </MenuItem>
    </MenuComponent>
  );
};
